// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"5e91124c","513":"1c7232f0","703":"f6d26b74","787":"7e212224"}[chunkId] + ".chunk.js";
};